module.exports = __webpack_public_path__ + "img/ja_redpacket.8a75e5b5.png";